/**
 * These constants are here to be able to import them during testing
 * without importing the index file since it would cause the tests to try and
 * compile the application related imports (which we don't want)
 */

export const APP_PATHS = {
  ADDITIONAL_PRODUCT_CONFIRMATION_PATH: 'additional-product-confirmation',
  APPLICATION_CONFIRMATION_PATH: 'application-confirmation',
  ENABLE_PAYOUTS_PATH: 'enable-payouts',
  PAYOUTS_CONFIRMATION_PATH: 'payouts-confirmation',
  PRICING_PATH: 'pricing',
  PSP_PATH: 'psp',
  PRODUCT_SELECTION_PATH: 'product-selection',
  START: '/',
  APPLICATION_OVERVIEW_PATH: 'application-overview',
  WHATS_NEXT_PATH: 'whats-next',
  MID_SELECTOR: 'mid-selector',
  BPC_POC: 'bpc-poc',
  MERCHANT_VERIFICATION_REVIEW_INFO_PATH: 'merchant-verification/review',
};

export const BASIC_STEP_PATHS = {
  SIGNUP_GATEWAY: 'signup-gateway',
  BASIC_INFO: 'signup/basic-info',
  COUNTRY_MANUAL: 'signup/manual-country',
  VOLUME_SEPARATION: 'signup/volume-separation',
  SENSITIVE_GOODS: 'signup/sensitive-goods',
  PLATFORM: 'signup/platform',
  PLATFORM_OTHER: 'signup/platform-other',
  ACCOUNT_CREATION_LOADING: 'signup/account-creation-loading',
  CONTACT_DETAILS: 'signup/contact-details',
  INVALID_SPECIAL_OFFER: 'signup/invalid-special-offer',
  PRODUCT_SELECTION_SIGNUP_PATH: `signup/${APP_PATHS.PRODUCT_SELECTION_PATH}`,
  PRODUCT_SELECTION_PATH: APP_PATHS.PRODUCT_SELECTION_PATH,
  ADDITIONAL_PRODUCT_CONFIRMATION_PATH: 'additional-product-confirmation',
};

export const BUSINESS_STEP_PATHS = {
  STORE_DETAILS_PATH: 'store-details',
  VAT_ID_PATH: 'vat-id',
  ENTITY_TYPE_SELECTION_PATH: 'entity-type-selection',
  COMPANY_DETAILS_PATH: 'company-details',
  COMPANY_REGISTRATION_PATH: 'company-registration-id',
};

export const STAKEHOLDER_STEP_PATHS = {
  APPLICANT_PATH: 'applicant',
  ARTIFICIAL_ULTIMATE_BENEFICIAL_OWNER_PATH: 'ceo',
  CONTROL_OVER_MANAGEMENT_PATH: 'control-over-management',
  DOCUMENTS: 'documents',
  PARTNERS_PATH: 'partners',
  PARTNERSHIP_DETAILS_PATH: 'partnership-details',
  SOLE_TRADER_PATH: 'sole-trader',
  ULTIMATE_BENEFICIAL_OWNER_PATH: 'ultimate-beneficial-owner',
};

export const BANK_ACCOUNT_STEP_PATHS = { BANK_ACCOUNT_PATH: 'bank-account' };

export const FLOW_STEP_PATHS = {
  ...BASIC_STEP_PATHS,
  ...BUSINESS_STEP_PATHS,
  ...STAKEHOLDER_STEP_PATHS,
  ...BANK_ACCOUNT_STEP_PATHS,
  APPLICATION_CHECKING_PATH: 'application-checking',
  APPLICATION_SUCCESS_PATH: 'application-success',
  APPLICATION_CONFIRMATION_PATH: 'application-confirmation',
  ENABLE_PAYOUTS_PATH: APP_PATHS.ENABLE_PAYOUTS_PATH,
  PAYOUTS_CONFIRMATION_PATH: APP_PATHS.PAYOUTS_CONFIRMATION_PATH,
  APPLICATION_OVERVIEW_PATH: 'application-overview',
  APPLICATION_REVIEW: 'application-review',
  PLATFORM_NATIVE: 'signup/native-partner',
  CONTACT_RECEIVED: 'signup/contact-received',
  WE_ARE_SORRY: 'signup/we-are-sorry',
  USER_ALREADY_EXISTS: 'signup/user-already-exists',
  KUSTOM_WE_ARE_SORRY: 'signup/we-are-sorry-kustom',
};

export const PRE_ASSESSMENT_STEP_PATHS = {
  UNDERWRITING_INFO_STEP: 'underwriting-info',
  BUSINESS_CONCEPT_STEP: 'business-concept',
  PRE_ASSESSMENT_COMPANY_DETAILS_STEP: 'pre-assessment-company-details',
  CONFIRM_MERCHANT_COPY_STEP: 'confirm-copy',
  SELLING_COUNTRIES_STEP: 'selling-countries',
  MAIN_SELLING_COUNTRY_STEP: 'main-selling-country',
  PRE_ASSESSMENT_PRODUCTS_STEP: 'pre-assessment-products',
  FCA_NUMBER_STEP: 'fca-number',

  HIGH_PML_QUESTIONNAIRE: 'high-pml-questionnaire',

  HIGH_EXPOSURE_SEGMENT_TRAVEL_SERVICES_QUESTIONNAIRE:
    'high-exposure-travel-services-questionnaire',
  HIGH_EXPOSURE_SEGMENT_EVENT_TICKETS_QUESTIONNAIRE: 'high-exposure-event-tickets-questionnaire',
  HIGH_EXPOSURE_SEGMENT_DIGITAL_SERVICES_QUESTIONNAIRE:
    'high-exposure-digital-services-questionnaire',
  HIGH_EXPOSURE_SEGMENT_OTHER_SERVICES_QUESTIONNAIRE: 'high-exposure-other-services-questionnaire',
  HIGH_EXPOSURE_SEGMENT_EDUCATION_QUESTIONNAIRE: 'high-exposure-education-questionnaire',
  HIGH_EXPOSURE_SEGMENT_CUSTOMES_AND_PARTY_SUPPLIES_QUESTIONNAIRE:
    'high-exposure-costumes-and-party-supplies-questionnaire',
  HIGH_EXPOSURE_BUSINESS_CONCEPT_VOUCHER_QUESTIONNAIRE: 'high-exposure-voucher-questionnaire',
  HIGH_EXPOSURE_BUSINESS_CONCEPT_MEMBERSHIP_QUESTIONNAIRE: 'high-exposure-membership-questionnaire',
  HIGH_EXPOSURE_BUSINESS_CONCEPT_SUBSCRIPTION_QUESTIONNAIRE:
    'high-exposure-subscription-questionnaire',

  BUSINESS_CONCEPT_TRAVEL_QUESTIONNAIRE: 'travel-questionnaire',
  BUSINESS_CONCEPT_AUCTIONS_QUESTIONNAIRE: 'auctions-questionnaire',
  BUSINESS_CONCEPT_MARKETPLACES_QUESTIONNAIRE: 'marketplaces-questionnaire',
  BUSINESS_CONCEPT_FIREARM_DEALERS_QUESTIONNAIRE: 'firearm-dealers-questionnaire',
  BUSINESS_CONCEPT_PHARMACIES_QUESTIONNAIRE: 'pharmacies-questionnaire',
  BUSINESS_CONCEPT_US_PHARMACIES_QUESTIONNAIRE: 'us-pharmacies-questionnaire',
  BUSINESS_CONCEPT_MEDICAL_SERVICES_QUESTIONNAIRE: 'medical-services-questionnaire',
  BUSINESS_CONCEPT_ALCOHOL_QUESTIONNAIRE: 'alcohol-questionnaire',
  BUSINESS_CONCEPT_TOBACCO_QUESTIONNAIRE: 'tobacco-questionnaire',
  BUSINESS_CONCEPT_HEMP_CBD_THC_QUESTIONNAIRE: 'hemp-cbd-thc-questionnaire',
  BUSINESS_CONCEPT_DONATIONS_CHARITY_QUESTIONNAIRE: 'donations-charity-questionnaire',
  BUSINESS_CONCEPT_GAMING_INDUSTRY_QUESTIONNAIRE: 'gaming-industry-questionnaire',
  BUSINESS_CONCEPT_DIGITAL_CONTENT_QUESTIONNAIRE: 'digital-content-questionnaire',
  BUSINESS_CONCEPT_CUSTOMISED_PRE_ORDER_FURNITURE_QUESTIONNAIRE:
    'customised-pre-order-furniture-questionnaire',
  BUSINESS_CONCEPT_FOOD_DELIVERY_QUESTIONNAIRE: 'food-delivery-questionnaire',
  BUSINESS_CONCEPT_EDUCATIONAL_COURSES_QUESTIONNAIRE: 'educational-courses-questionnaire',
  BUSINESS_CONCEPT_TRADITIONAL_SALE_OF_GOODS_QUESTIONNAIRE:
    'traditional-sale-of-goods-questionnaire',
  BUSINESS_CONCEPT_EROTIC_SERVICES_QUESTIONNAIRE: 'erotic-services-questionnaire',
  BUSINESS_CONCEPT_FINANCIAL_SERVICES_QUESTIONNAIRE: 'financial-services-questionnaire',
  BUSINESS_CONCEPT_SOCIAL_PLATFORMS_COMMUNITIES_QUESTIONNAIRE:
    'social-platforms-communities-questionnaire',
  BUSINESS_CONCEPT_GAMBLING_BETTING_CASINOS_AND_LOTTERY_QUESTIONNAIRE:
    'gambling-betting-casinos-and-lottery-questionnaire',
  GOODS_CATEGORY_EVENT_BROKER_AND_AGENCIES_QUESTIONNAIRE: 'event-broker-and-agencies-questionnaire',
  GOODS_CATEGORY_EVENT_ORGANIZER_QUESTIONNAIRE: 'event-organizer-questionnaire',
  GOODS_CATEGORY_TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS_QUESTIONNAIRE:
    'travel-air-travel-and-cruise-operators-questionnaire',
  GOODS_CATEGORY_TRAVEL_GROUND_TRANSPORTATION_QUESTIONNAIRE:
    'travel-ground-transportation-questionnaire',
  GOODS_CATEGORY_TRAVEL_ACCOMMODATION_AND_RESORTS_QUESTIONNAIRE:
    'travel-accommodation-and-resorts-questionnaire',
  GOODS_CATEGORY_TRAVEL_BROKER_AND_AGENCIES_QUESTIONNAIRE:
    'travel-broker-and-agencies-questionnaire',

  SUMMARY_STEP: 'pre-assessment-summary',
  OVERVIEW_STEP: 'pre-assessment-overview',
  WRONG_PREFILL_DATA: 'pre-assessment-wrong-prefill-data',
};

export const RECOLLECTION_STEP_PATHS = {
  INTRODUCTION_PATH: 'introduction',
  UBO_PATH: 'ubo',
  CEO_PATH: 'ceo',
  CONFIRMATION_PATH: 'confirmation',
  OVERVIEW_PATH: 'overview',
  APPLICANT_PATH: 'applicant',
};

export const DOCUMENT_UPLOAD_STEP_PATHS = {
  DOCUMENTS: 'documents',
  SUCCESS_PATH: 'success',
};

export const MERCHANT_VERIFICATION_STEP_PATHS = {
  VERIFICATION_INFO: 'merchant-verification/info',
  VERIFICATION_OVERVIEW: 'merchant-verification/overview',
  VERIFICATION_DATA_COLLECTION: 'merchant-verification/data',
  VERIFICATION_SUCCESS_PATH: 'merchant-verification/success',
};

export const FLOW_THEMES = {
  // Step 1 (signup)
  [FLOW_STEP_PATHS.ACCOUNT_CREATION_LOADING]: 'step1',
  [FLOW_STEP_PATHS.BASIC_INFO]: 'step1',
  [FLOW_STEP_PATHS.CONTACT_DETAILS]: 'step1',
  [FLOW_STEP_PATHS.CONTACT_RECEIVED]: 'step1',
  [FLOW_STEP_PATHS.WE_ARE_SORRY]: 'step1',
  [FLOW_STEP_PATHS.COUNTRY_MANUAL]: 'step1',
  [FLOW_STEP_PATHS.INVALID_SPECIAL_OFFER]: 'step1',
  [FLOW_STEP_PATHS.PLATFORM_OTHER]: 'step1',
  [FLOW_STEP_PATHS.PLATFORM]: 'step1',
  [FLOW_STEP_PATHS.PRODUCT_SELECTION_PATH]: 'step1',
  [FLOW_STEP_PATHS.USER_ALREADY_EXISTS]: 'step1',
  [FLOW_STEP_PATHS.VOLUME_SEPARATION]: 'step1',
  [FLOW_STEP_PATHS.KUSTOM_WE_ARE_SORRY]: 'step1',

  // Step 2 (store, business and stakeholders)
  [FLOW_STEP_PATHS.APPLICANT_PATH]: 'step2',
  [FLOW_STEP_PATHS.ARTIFICIAL_ULTIMATE_BENEFICIAL_OWNER_PATH]: 'step2',
  [FLOW_STEP_PATHS.BANK_ACCOUNT_PATH]: 'step2',
  [FLOW_STEP_PATHS.COMPANY_DETAILS_PATH]: 'step2',
  [FLOW_STEP_PATHS.COMPANY_REGISTRATION_PATH]: 'step2',
  [FLOW_STEP_PATHS.CONTROL_OVER_MANAGEMENT_PATH]: 'step2',
  [FLOW_STEP_PATHS.ENTITY_TYPE_SELECTION_PATH]: 'step2',
  [FLOW_STEP_PATHS.PARTNERS_PATH]: 'step2',
  [FLOW_STEP_PATHS.PARTNERSHIP_DETAILS_PATH]: 'step2',
  [FLOW_STEP_PATHS.SOLE_TRADER_PATH]: 'step2',
  [FLOW_STEP_PATHS.STORE_DETAILS_PATH]: 'step2',
  [FLOW_STEP_PATHS.ULTIMATE_BENEFICIAL_OWNER_PATH]: 'step2',
  [FLOW_STEP_PATHS.VAT_ID_PATH]: 'step2',

  // Step 3 (confirmation, overview and review)
  [FLOW_STEP_PATHS.APPLICATION_CHECKING_PATH]: 'step3',
  [FLOW_STEP_PATHS.APPLICATION_CONFIRMATION_PATH]: 'step3',
  [FLOW_STEP_PATHS.APPLICATION_OVERVIEW_PATH]: 'step3',
  [FLOW_STEP_PATHS.APPLICATION_REVIEW]: 'step3',
};
